import { useQuery } from 'react-query';

import { getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered } from 'src/client/spendesk-api';
import { type GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredResponseOK } from 'src/client/spendesk-api-types';
import { type QueryError } from 'src/core/api/queryError';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

type Options = {
  enabled?: boolean;
};

export const useDeliveryNotesQuantityDeliveredQuery = (
  requestId: string,
  { enabled = true }: Options = {},
) => {
  const company = useCompany();

  return useQuery<
    GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredResponseOK,
    QueryError<unknown>
  >(
    ['purchase-orders', requestId, 'quantity-delivered'],
    async (): Promise<GetV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDeliveredResponseOK> => {
      const response =
        await getV2ApiCompanyIdPurchaseOrdersRequestIdQuantityDelivered({
          path: { companyId: company.id, requestId },
        });
      if (response.statusCode !== 200) {
        throw new Error(
          `Invalid quantity delivered result ${response.body.reason}`,
        );
      }
      return response.body;
    },
    {
      enabled,
    },
  );
};
